module.exports = __webpack_public_path__ + "img/img-p.f199342b.png";